<template>
    <div class="tw:grid tw:grid-cols-1 tw:sm:grid-cols-2 tw:md:grid-cols-3 tw:lg:grid-cols-3 tw:gap-3">
        <BaseMultiselect
            name="search_for"
            label="Buscar por"
            :options="[
                { id: 'nombre', label: 'Nombre' },
                { id: 'apellidos', label: 'Apellidos' }
            ]"
            value-key="id"
            label-key="label"
            :value="local.search_for"
            @input="val => local.search_for = (val ?? '')"
        />

        <BaseMultiselect
            name="categoria"
            label="Categoría"
            :options="categorias"
            value-key="id"
            label-key="name"
            :value="local.categoria"
            :disabled="categorias.length === 0"
            @input="val => local.categoria = (val ?? '')"
        />

        <BaseMultiselect
            name="metodo_pago"
            label="Método de pago"
            :options="metodos_pago"
            value-key="id"
            label-key="nombre"
            :value="local.metodo_pago"
            :disabled="metodos_pago.length === 0"
            @input="val => local.metodo_pago = (val ?? '')"
        />

        <div class="tw:flex tw:flex-col tw:sm:flex-row tw:items-stretch tw:sm:items-end tw:gap-2 tw:col-span-1 tw:sm:col-span-2 tw:md:col-span-3 tw:lg:col-span-3 tw:sm:justify-end">
            <Button
                customClass="tw:w-full tw:sm:w-auto"
                @click="resetFilters"
            >
                Limpiar filtros
            </Button>
            <slot name="actions" ></slot>
        </div>
    </div>
</template>

<script setup>
    import { reactive, watch } from 'vue';
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue';
    import Button from '@/modules/admin/ui/Button.vue';

    const props = defineProps({
        filters: {
            type: Object,
            required: true
        },
        categorias: {
            type: Array,
            default: () => []
        },
        metodos_pago: {
            type: Array,
            default: () => []
        }
    });

    const emit = defineEmits(['reset', 'update:filters']);

    const local = reactive({ ...props.filters });

    watch(
        () => props.filters,
        newVal => {
            if (!newVal) return;
            Object.assign(local, newVal);
        },
        { deep: true }
    );

    watch(
        local,
        val => {
            emit('update:filters', { ...val });
        },
        { deep: true }
    );

    function resetFilters() {
        emit('reset');
    }
</script>
